import React, { Component } from 'react';
import { Modal, Form, InputNumber, Button } from 'antd';

class SyncPolarityModal extends Component {
    state = {
        polarityValue: this.props.fibersPerCable,
        containsDarkFibers: false
    }
    close = () => {
        if(this.state.containsDarkFibers) {
            this.setState({containsDarkFibers: false})
            alert("Dark fiber detectors must be entered manually.")
        }
        this.props.close();
    }

    syncPolarities = async () => {
        const values = this.props.polarityMap;
        await this.props.update((state) => {
            let detectors = [...state.detectors];
            let valuesIndex = 0;
            detectors.forEach((_, index) => {
                valuesIndex = index >= values.length ? values.length: 0;
                detectors[index] = Math.floor((values[index - valuesIndex]-1)/this.state.polarityValue) + 1;
                if(detectors[index] === 0) {
                    this.setState({containsDarkFibers: true});
                }
            })
            return { detectors };
        })
        this.close();
    }

    render() {
        return(
            <Modal
                title="Sync with Polarity"
                open={this.props.isOpen}
                onCancel={() => {
                    this.close();
                }}
                width={250}
                footer={[
                    <Button key="save" type="primary" disabled={this.state.polarityValue==null} onClick={() => {this.syncPolarities()}}>Sync</Button>,
                    <Button key="back" onClick={this.close}>Cancel</Button>
                ]}
            >
                <div style={{height: '60px'}}>
                    <div>
                        Fibers per detector:
                    </div>
                    <Form>
                        <Form.Item
                            name="polarityValue"
                            rules={[
                                {
                                    required: true,
                                    message: 'Number of fibers cannot be empty.'
                                }
                            ]}
                        >
                            <InputNumber min={1} defaultValue={this.state.polarityValue} onChange={(e) => this.setState({polarityValue: e})}/>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );
    }
}

export default SyncPolarityModal;